'use client';
import { useEffect } from 'react';

type AsyncCssLoaderProps = {
  href: string;
};

export const AsyncCssLoader = ({ href }: AsyncCssLoaderProps) => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'style';
    link.href = href;
    link.onload = () => {
      link.rel = 'stylesheet';
      link.onload = null;
    };
    document.head.appendChild(link);
  }, []);

  return null;
};
